import { Chip } from "@mui/material";
import { PrescriptionResponseDtoStatusEnum } from "libs/cellera-sdk";
import { useCallback, useMemo } from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";

export const StatusTag = ({
  status,
}: {
  status: PrescriptionResponseDtoStatusEnum;
}) => {
  const { colors } = useCelleraTheme();
  const getStatusDisplay = useCallback(
    (status: string) => {
      switch (status) {
        case PrescriptionResponseDtoStatusEnum.Paid:
          return {
            backgroundColor: colors.success[100],
            color: colors.success[700],
          };
        case PrescriptionResponseDtoStatusEnum.Cancelled:
          return {
            backgroundColor: colors.error[100],
            color: colors.error[700],
          };
        case PrescriptionResponseDtoStatusEnum.Pending:
        default:
          return {
            backgroundColor: colors.warning[100],
            color: colors.warning[700],
          };
      }
    },
    [colors.error, colors.success, colors.warning],
  );
  const statusDisplay = useMemo(
    () => getStatusDisplay(status),
    [getStatusDisplay, status],
  );
  return (
    <Chip
      label={status.toUpperCase()}
      size="small"
      sx={{
        backgroundColor: statusDisplay.backgroundColor,
        color: statusDisplay.color,
        fontWeight: 600,
        fontSize: "0.75rem",
        borderRadius: 0,
        border: `1px solid ${statusDisplay.color}`,
      }}
    />
  );
};
